import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  label: '📘 Aligner Control System™ — 6 premium volumes',
  value: '$97'
}, {
  label: '🎁 5 professional bonuses',
  value: '$167'
}, {
  label: '📋 30+ protocols, checklists & tools',
  value: '$67'
}];
const perks = ['No monthly fees', 'Lifetime access', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-221" data-mp="3f3i6v1a02hxe">
      <div className="mx-auto w-full max-w-3xl px-4" data-id="element-222" data-mp="3juqepsvolv8g">
        <div className="text-center" data-id="element-223" data-mp="3jw1s8kexihcr">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-sky-400" data-id="element-224" data-mp="3nwlq5q7btozy">
            🏆 Special launch offer
          </p>
          <h2 className="mt-3 font-display text-[26px] font-black uppercase leading-[1.12] text-white sm:text-4xl" data-id="element-225" data-mp="3sx9da0sfplow">
            Here’s everything you get today
          </h2>
        </div>

        <div className="mt-8 rounded-3xl bg-white p-5 sm:p-8" data-id="element-226" data-mp="1kmj92iwxpyvk">
          <ul className="flex flex-col divide-y divide-navy-100" data-id="element-227" data-mp="1fmn7srfmgljp">
            {stack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-228" data-mp="1bkidrrl9hmwj">
                <span className="text-sm font-semibold text-navy-700 sm:text-base" data-id="element-229" data-mp="16n9vlr045iva">
                  {item.label}
                </span>
                <span className="shrink-0 text-sm font-bold text-navy-400 line-through sm:text-base" data-id="element-230" data-mp="23dsplc54hnwn">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-4 flex items-center justify-between gap-4 rounded-2xl bg-navy-50 px-4 py-3" data-id="element-231" data-mp="1pkkv9cpnqeb9">
            <span className="font-display text-xs font-black uppercase tracking-wide text-navy-700 sm:text-sm" data-id="element-232" data-mp="2mzoy94l9fbgz">
              Total perceived value
            </span>
            <span className="font-display text-xl font-black text-navy-400 line-through sm:text-2xl" data-id="element-233" data-mp="2i7xdxbsp61za">
              $331
            </span>
          </div>

          <div className="mt-6 text-center" data-id="element-234" data-mp="364ts4so4usxo">
            <p className="text-xs font-extrabold uppercase tracking-[0.16em] text-navy-500" data-id="element-235" data-mp="366oco5vhsj18">
              Today you get everything for only
            </p>
            <p className="mt-1 font-display text-6xl font-black leading-none text-navy-800 sm:text-7xl" data-id="element-236" data-mp="2wdpcdqqmv41s">
              $27
            </p>
            <p className="mt-2 text-sm font-extrabold uppercase tracking-wide text-sky-600" data-id="element-237" data-mp="2ih2g7q6i8hwx">
              One-time payment
            </p>

            <ul className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-238" data-mp="29et5p0b8kojj">
              {perks.map(perk => <li key={perk} className="flex items-center gap-1.5 rounded-lg bg-navy-50 px-2.5 py-1.5 text-xs font-bold text-navy-700" data-id="element-239" data-mp="2dgxw7q6e151y">
                  <CheckIcon className="h-3.5 w-3.5 text-sky-500" aria-hidden="true" data-id="element-240" data-mp="bni6cvi4ju81" />
                  {perk}
                </li>)}
            </ul>

            <p className="mt-4 flex items-center justify-center gap-2 rounded-xl bg-mint/15 px-3 py-2.5 text-xs font-semibold text-navy-700 sm:text-sm" data-id="element-241" data-mp="1s6jxbno89uga">
              <GlobeIcon className="h-4 w-4 shrink-0 text-mint" aria-hidden="true" data-id="element-242" data-mp="215x3o7h222ws" />
              Currency is converted automatically — pay in your local currency.
            </p>

            <p className="mt-4 text-sm leading-relaxed text-navy-600" data-id="element-243" data-mp="2auf58qx5se1h">
              For less than the cost of a typical professional lunch, you get a
              complete digital system designed to help you organize your aligner
              workflow whenever you need it.
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center gap-5" data-id="element-244" data-mp="uhgtmm4cb7dw">
          <CTAButton label="Get Aligner Control System™" subline="Only $27 · One-time payment · Lifetime access · 7-day guarantee" data-id="element-245" data-mp="pix8gnxklzml" />
          <Countdown data-id="element-246" data-mp="vydrvy4upeg3" />
          <ScarcityBar data-id="element-247" data-mp="vxujp95064f9" />
        </div>
      </div>
    </section>;
}